import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import { CSSProperties } from 'react';
import * as Request from '../tgccRequest';
import ImageModal from '../Components/ImageModal';

const woStyle: CSSProperties = {
  fontSize: '35px',
  letterSpacing: '12px',
  fontWeight: 'lighter',
  textTransform: 'uppercase',
  color: 'rgba(88,88,88,0.8)',
  textAlign: 'center',
  margin: '8px 0 0 0',
  '@media (max-width: 768px)': {
    flexDirection: 'column',
  },
};

const contentStyle: CSSProperties = {
  display: 'flex',
  backgroundColor: 'rgb(244, 250, 255)',
  justifyContent: 'space-around',
  alignItems: 'center',
  flexWrap: 'wrap',
  marginBottom: '20px',
  '@media (max-width: 768px)': {
    flexDirection: 'column',
  },
};

const imgStyle: CSSProperties = {
  alignSelf: 'center',
  width: 'auto',
  height: 'auto',
  maxHeight: '560px',
  margin: '25px auto',
};

const wrapperStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: 'rgb(244, 250, 255)',
  justifyContent: 'center',
  marginTop: '80px',
  '@media (max-width: 768px)': {
    marginTop: '20px',
    width: '100%',
  },
};

/** CED: match tight subheader↔banner rhythm (~10px), avoid large white band under wood banner. */
const cedWrapperStyle: CSSProperties = {
  ...wrapperStyle,
  marginTop: '10px',
  '@media (max-width: 768px)': {
    marginTop: '10px',
    width: '100%',
  },
};

const imagesRowStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'space-around',
  alignItems: 'center',
  width: '100%',
  flexWrap: 'wrap',
  marginBottom: '10px', // Add space between rows
};

const imagesContainerStyle: CSSProperties = {
  display: 'flex',
  width: '65vw',
  margin: '0 auto',
  backgroundColor: 'white',
  justifyContent: 'space-around',
  alignItems: 'center',
  boxShadow: '0 4px 8px 0 rgba(0, 0, 0, 0.2)',
  flexWrap: 'wrap',
  marginBottom: '20px',
};

const imageStyle: CSSProperties = {
  maxWidth: '45%',
  height: 'auto',
  boxSizing: 'border-box',
  padding: '5px',
  '@media (max-width: 768px)': {
    maxWidth: '90%', // Increase for better mobile visibility
    marginBottom: '15px', // Ensure space between images
  },
};

const imageContainerStyle: CSSProperties = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  '@media (max-width: 768px)': {
    flexDirection: 'column',
  },
};

const clickToEnlargeStyle: CSSProperties = {
  textAlign: 'center',
  fontSize: '12px', // Small, but legible size
  color: '#666', // Subtle color, but feel free to adjust
  marginTop: '10px',
  marginBottom: '10px',
  '@media (max-width: 768px)': {
    display: 'none',
  },
};

const imageCaptionStyle: CSSProperties = {
  textAlign: 'center',
  fontSize: '14px',
  fontWeight: 'bold',
  color: '#333',
  marginTop: '8px',
  marginBottom: '15px',
  fontFamily: 'CenturyGothic',
  '@media (max-width: 768px)': {
    fontSize: '12px',
    marginTop: '5px',
    marginBottom: '10px',
  },
};

const imageWrapperStyle: CSSProperties = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  margin: '5px',
  '@media (max-width: 768px)': {
    margin: '3px',
  },
};

const fallbackImageStyle: CSSProperties = {
  maxHeight: '800px', // Adjust this value as needed
  width: 'auto',
  height: 'auto',
  boxSizing: 'border-box',
  padding: '5px',
  display: 'block', // Ensure the image is block level to center it if necessary
  marginLeft: 'auto',
  marginRight: 'auto',
};

const countdownStyle: CSSProperties = {
  fontWeight: 700,
  fontSize: '28px',
  color: '#FFFFFF',
  textShadow: '0px 1px 3px rgba(0, 0, 0, 0.6)',
  fontFamily: '"Source Code Pro", monospace',
  margin: '10px 0',
  padding: '15px 20px',
  borderRadius: '10px',
  backgroundColor: '#007bff',
  display: 'inline-block',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
  border: '2px solid #0056b3',
  animation: 'pulseAnimation 2s infinite',
  '@media (max-width: 768px)': {
    fontSize: '20px',
    padding: '10px 15px',
  },
  '@keyframes pulseAnimation': {
    '0%': { backgroundColor: '#007bff' },
    '50%': { backgroundColor: '#0056b3' },
    '100%': { backgroundColor: '#007bff' },
  },
};

const headerStyle: CSSProperties = {
  fontSize: '34px',
  fontWeight: 900,
  textTransform: 'math-auto',
  textAlign: 'center',
  textDecoration: 'underline',
  marginBottom: '40px',
  fontFamily: '"RocknRoll One", sans-serif', // Specify the font family here
  '@media (max-width: 768px)': {
    fontSize: '24px', // Smaller header font size for mobile
    marginBottom: '20px', // Less bottom margin for mobile
  },
};

const subTextStyle: CSSProperties = {
  textAlign: 'center',
  marginBottom: '60px',
  fontSize: '19px',
  textTransform: 'math-auto',
  fontFamily: '"RocknRoll One", sans-serif', // And here
  '@media (max-width: 768px)': {
    fontSize: '15px', // Smaller text for mobile
    marginBottom: '30px', // Less bottom margin for mobile
  },
};

const readyDiv: CSSProperties = {
  marginBottom: '40px',
  '@media (max-width: 768px)': {
    marginBottom: '20px', // Less bottom margin for mobile
  },
};

type Props = {
  tvite: any;
};

export class TViteProofCard extends React.Component<Props, any> {
  private interval: NodeJS.Timeout | undefined;

  constructor(props: Props) {
    super(props);
    this.state = {
      isModalOpen: false,
      currentImageSrc: '',
      proofImages: [],
      closingDate: null,
      countdown: '',
    };
  }

  componentDidMount() {
    this.loadProofImages();
    if (this.props.tvite.specialWebstore !== 'CED') {
      this.fetchClosingDateFromAPI();
      this.interval = setInterval(this.updateCountdown, 1000);
    }
  }

  componentWillUnmount() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  }

  fetchClosingDateFromAPI = () => {
    Request.fetchClosingDate(
      this.props.tvite.proofId,
      'tvite/getStoreClosingDate',
      (closingDate) => {
        if (closingDate) {
          this.setState({ closingDate: new Date(closingDate) });
        } else {
          this.setState({ closingDate: null });
        }
      },
      (error) => {
        console.error('Failed to fetch closing date:', error);
        this.setState({ closingDate: null });
      }
    );
  };

  updateCountdown = () => {
    const { closingDate } = this.state;
    if (!closingDate) {
      return;
    }

    const now = new Date();
    const timeLeft = closingDate.getTime() - now.getTime();

    if (timeLeft > 0) {
      let countdownArray = [];

      const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
      if (days > 0) countdownArray.push(`${days} days`);

      const hours = Math.floor((timeLeft / (1000 * 60 * 60)) % 24);
      if (days > 0 || hours > 0) countdownArray.push(`${hours} hours`);

      const minutes = Math.floor((timeLeft / 1000 / 60) % 60);
      if (days > 0 || hours > 0 || minutes > 0) countdownArray.push(`${minutes} minutes`);

      const seconds = Math.floor((timeLeft / 1000) % 60);
      countdownArray.push(`${seconds} seconds`);

      const countdown = countdownArray.join(' ');
      this.setState({ countdown });
    } else if (this.interval) {
      clearInterval(this.interval);
      this.setState({ countdown: "The store has closed." });
    }
  };

  loadProofImages = () => {
    console.log('Loading proof images for proofId:', this.props.tvite.proofId);
    Request.fetchImageUrlsFromBlob(this.props.tvite.proofId, this.loaded, this.error);
  };

  loaded = (imageFilenames: string[]) => {
    console.log('Received image filenames:', imageFilenames);

    var proofId = this.props.tvite.proofId.replace(/^WO/, '');
    const baseUrl = `https://grafcowassets.blob.core.windows.net/tgcc-proof-assets/${proofId}`;
    const fullImageUrls = imageFilenames.map((filename) => {
      const filenameWithoutPrefix = filename.startsWith(`${proofId}/`) ? filename.slice(proofId.length + 1) : filename;
      const finalUrl = `${baseUrl}/${filenameWithoutPrefix}`;
      console.log('Constructed URL:', finalUrl);
      return finalUrl;
    });

    const sortedImageUrls = this.sortImages(fullImageUrls);
    this.setState({ proofImages: sortedImageUrls });
  };

  sortImages = (images: string[]) => {
    const order = ['front', 'back', 'description'];

    return images.sort((a, b) => {
      const aIndex = order.findIndex((keyword) => a.includes(keyword));
      const bIndex = order.findIndex((keyword) => b.includes(keyword));

      if (aIndex !== -1 && bIndex !== -1) return aIndex - bIndex;
      if (aIndex !== -1) return -1;
      if (bIndex !== -1) return 1;

      return a.localeCompare(b);
    });
  };

  error = (err: any) => {
    console.error('Error loading images:', err);
    const defaultImage = Tgcc.getProofPath(this.props.tvite.proofId);
    this.setState({ proofImages: [{ src: defaultImage, isFallback: true }] });
  };

  handleImageClick = (imgSrc: string) => {
    if (window.innerWidth > 768) {
      this.setState({ isModalOpen: true, currentImageSrc: imgSrc });
    }
  };

  handleCloseModal = () => {
    this.setState({ isModalOpen: false });
  };

  renderHeader = () => {
    const { closingDate, countdown } = this.state;
    const { status, specialWebstore, proofId } = this.props.tvite;

    if (status === 'CLOSED') {
      return (
        <div>
          <h2 style={headerStyle}>The T-Vite is Now Closed</h2>
        </div>
      );
    }

    // For WO773171 and WO773246, don't render any header content
    if (proofId === 'WO773171' || proofId === 'WO773246') {
      return null;
    }

    // CED: no countdown / close-date banner
    if (specialWebstore === 'CED') {
      return null;
    }

    if (closingDate && countdown) {
      return (
        <div>
          <h2 style={headerStyle}>Order Your Merch</h2>
          <p style={subTextStyle}>
            <span style={countdownStyle}>
              <div>Store closes in:</div>
              {countdown}
            </span>
          </p>
          {specialWebstore !== 'PapaJohns' &&  (
            <p style={subTextStyle}>
              <div style={readyDiv}>Eager to get started?</div>
              {proofId === 'WO748640' ? (
                "From their U.S. grown ring spun cotton construction and blends to their Clean Canvas print technology face, our Perfect-Ts are meant for more. More daring embellishments, more stylish fit and more for those with a sense of fashion (offering both solid & CVC shades).\n\nExperience the perfection by redeeming a free decorated sample!"
              ) : (
                "Explore the designs below. You can choose your preferred sizes and quantities, whether it's for a bulk organization order or a personal shipment to your address."
              )}
            </p>
          )}
        </div>
      );
    }

    return null; // If no closing date and status is not CLOSED, render nothing
  };

  renderImages = () => {
    const isFallbackImage = this.state.proofImages.length > 0 && typeof this.state.proofImages[0] === 'object' && this.state.proofImages[0].isFallback;
    const isWO773171 = this.props.tvite.proofId === 'WO773171' || this.props.tvite.proofId === 'WO773246';

    if (isFallbackImage) {
      const fallbackImageSrc = this.state.proofImages[0].src;
      return (
        <div style={imagesContainerStyle} className="tvite_image_container">
          <img style={fallbackImageStyle} id="fallBackImage" src={fallbackImageSrc} alt="Fallback Image" />
        </div>
      );
    }

    const frontImage = this.state.proofImages.find((image) => image.includes('front'));
    const backImage = this.state.proofImages.find((image) => image.includes('back'));
    const descriptionImage = this.state.proofImages.find((image) => image.includes('description'));
    let otherImages = this.state.proofImages.filter((image) => !image.includes('front') && !image.includes('back') && !image.includes('description'));

    // For WO773171, sort the other images in the specific order: Yellow, Orange, Red
    if (isWO773171) {
      otherImages = otherImages.sort((a, b) => {
        const aIsYellow = a.includes('YellowShirt');
        const bIsYellow = b.includes('YellowShirt');
        const aIsOrange = a.includes('OrangeShirt');
        const bIsOrange = b.includes('OrangeShirt');
        const aIsRed = a.includes('RedShirt');
        const bIsRed = b.includes('RedShirt');

        // Yellow should come first
        if (aIsYellow && !bIsYellow) return -1;
        if (!aIsYellow && bIsYellow) return 1;

        // Orange should come second
        if (aIsOrange && !bIsOrange) return -1;
        if (!aIsOrange && bIsOrange) return 1;

        // Red should come third
        if (aIsRed && !bIsRed) return -1;
        if (!aIsRed && bIsRed) return 1;

        return 0;
      });
    }

    const centerSingleImageStyle: CSSProperties = {
      justifyContent: 'center',
    };

    const imageRowDynamicStyle = frontImage && backImage ? imagesRowStyle : { ...imagesRowStyle, ...centerSingleImageStyle };

    const pairedOtherImages = [];
    for (let i = 0; i < otherImages.length; i += 2) {
      pairedOtherImages.push(otherImages.slice(i, i + 2));
    }

    // Helper function to get caption for WO773171 images
    const getImageCaption = (imageSrc: string) => {
      if (!isWO773171) return null;
      
      if (imageSrc.includes('YellowShirt')) {
        return <span><strong>GOOD |</strong> Hanes 5280 | Athletic Yellow</span>;
      } else if (imageSrc.includes('OrangeShirt')) {
        return <span><strong>BETTER |</strong> Hanes 4980 | Orange</span>;
      } else if (imageSrc.includes('RedShirt')) {
        return <span><strong>BEEFY |</strong> Hanes 5180 | Deep Red</span>;
      }
      return null;
    };

    // Helper function to render image with optional caption
    const renderImageWithCaption = (src: string, alt: string, onClick: () => void) => {
      const caption = getImageCaption(src);
      const img = (
        <img style={imageStyle} className="tvite_image" src={src} alt={alt} onClick={onClick} />
      );

      if (caption) {
        return (
          <div style={imageWrapperStyle}>
            {img}
            <div style={imageCaptionStyle}>{caption}</div>
          </div>
        );
      }

      return img;
    };

    return (
      <div style={imagesContainerStyle} className="tvite_image_container">
        <div style={{ width: '100%', textAlign: 'center' }}>
          <p style={clickToEnlargeStyle} id="clickToEnlarge">Click images to enlarge</p>
        </div>
        <div style={imageRowDynamicStyle}>
          {frontImage && renderImageWithCaption(frontImage, "Front", () => this.handleImageClick(frontImage))}
          {backImage && renderImageWithCaption(backImage, "Back", () => this.handleImageClick(backImage))}
        </div>

        {descriptionImage && (
          <div style={imagesRowStyle}>
            {renderImageWithCaption(descriptionImage, "Description", () => this.handleImageClick(descriptionImage))}
          </div>
        )}
        {pairedOtherImages.map((pair, index) => (
          <div key={`paired-other-${index}`} style={imagesRowStyle}>
            {pair.map((src, idx) => 
              renderImageWithCaption(src, `Other Image ${index}-${idx}`, () => this.handleImageClick(src))
            )}
          </div>
        ))}
      </div>
    );
  };

  render() {
    const isCed = this.props.tvite?.specialWebstore === 'CED';
    return (
      <div style={isCed ? cedWrapperStyle : wrapperStyle} className="wrapperStyle">
        {this.renderHeader()}
        <div style={contentStyle}>
          {this.renderImages()}
        </div>
        <ImageModal
          isOpen={this.state.isModalOpen}
          imgSrc={this.state.currentImageSrc}
          onClose={this.handleCloseModal}
        />
      </div>
    );
  }
}
